import React, { useEffect, useRef, useState, useCallback } from 'react';

function Autopara({ images = [], text = "" }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);

  const stopAutoScroll = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  }, []);

  const startAutoScroll = useCallback(() => {
    stopAutoScroll();
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 3000);
  }, [images.length, stopAutoScroll]);

  useEffect(() => {
    startAutoScroll();
    return stopAutoScroll;
  }, [startAutoScroll, stopAutoScroll]);

  return (
    <div className="flex flex-col md:flex-row gap-6 items-stretch justify-center p-6 bg-white max-w-7xl mx-auto shadow-md rounded-lg mt-16 mb-16">
      
      {/* Image Section */}
      <div
        className="relative w-full md:w-1/2 h-[250px] md:h-[350px] overflow-hidden rounded-lg"
        onMouseEnter={stopAutoScroll}
        onMouseLeave={startAutoScroll}
      >
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Slide ${index + 1}`}
            className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700 ease-in-out ${
              index === currentIndex ? 'opacity-100' : 'opacity-0'
            }`}
          />
        ))}
      </div>

      {/* Text Section */}
      <div className="w-full md:w-1/2 text-gray-800 text-justify leading-relaxed flex items-center md:pl-10">
        <p dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </div>
  );
}

export default Autopara;
